import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const HERO_ROTATION = [
  '/images/heroes/hero-1-spray.webp',
  '/images/heroes/hero-7-twilight-lobby.webp',
  '/images/heroes/hero-6-skyline-office.webp',
];

export function Hero() {
  const [idx, setIdx] = useState(0);

  const handleQuoteClick = () => {
    window.dispatchEvent(new CustomEvent('openContactForm'));
  };

  const nextSlide = useCallback(() => {
    setIdx((i) => (i + 1) % HERO_ROTATION.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="relative h-screen min-h-[700px] clip-diag-bottom overflow-hidden">
      <div className="absolute inset-0">
        {HERO_ROTATION.map((src, i) => (
          <div
            key={src}
            className={`hero-slide absolute inset-0 ${i === idx ? 'opacity-100' : 'opacity-0'}`}
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-cover ken-burns"
              loading={i === 0 ? 'eager' : 'lazy'}
            />
          </div>
        ))}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, rgba(15,15,30,.88) 0%, rgba(15,15,30,.55) 50%, rgba(0,180,216,.25) 100%)',
          }}
        />
        <div className="absolute inset-0 opacity-20 grid-pattern" />
      </div>

      <div className="relative z-10 h-full flex items-end pb-20 sm:pb-40 lg:pb-48">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
          <div className="max-w-4xl fade-in">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-[3px] w-16 bg-thunder" />
              <span className="text-thunder font-display tracking-[0.4em] text-xs">// ORLANDO · CENTRAL FL</span>
            </div>

            <h1 className="font-display font-bold text-white text-shadow-bold leading-[0.88] mb-2">
              <span className="block text-4xl sm:text-6xl md:text-7xl lg:text-9xl">WE BRING THE</span>
              <span
                className="block text-5xl sm:text-7xl md:text-8xl lg:text-[10rem] text-thunder"
                style={{ textShadow: '0 0 60px rgba(255,214,10,.5)' }}
              >
                BOOM
              </span>
              <span className="block text-3xl sm:text-5xl md:text-6xl lg:text-8xl mt-2">TO EVERY ROOM</span>
            </h1>

            <p className="text-white/80 text-lg sm:text-xl max-w-xl mt-8 mb-10 font-body font-light">
              Premium cleaning for homes, offices, and everything in between. Owner-led crews. Zero compromise.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <button
                onClick={handleQuoteClick}
                className="pulse-btn bg-electric hover:bg-electric-bright text-charcoal-deep font-display font-bold px-6 sm:px-10 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] transition glow-electric"
              >
                GET YOUR INSTANT QUOTE →
              </button>
              <a
                href="tel:4074616039"
                className="border-2 border-thunder text-thunder hover:bg-thunder hover:text-charcoal-deep font-display font-bold px-6 sm:px-10 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] transition"
              >
                &#x1F4DE; (407) 461-6039
              </a>
            </div>

            <div className="absolute bottom-32 left-6 lg:left-10 flex gap-2">
              {HERO_ROTATION.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  aria-label={`Slide ${i + 1}`}
                  className={`h-1 transition-all ${
                    i === idx ? 'w-16 bg-thunder' : 'w-8 bg-white/30'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
